import React, {useEffect, useState, useContext} from 'react';
import { Col, Card } from 'react-bootstrap';
import { TotalIssuesState, TotalReportersState, TotalPortsState, TotalFishermansState } from '../types/type';
import numberFormat from "../helpers/numberFormat"
import { UserContext } from "../context/UserContext";

export default (props) =>  {
  const userState = useContext(UserContext);

  const [totalIssues, setTotalIssues] = useState<TotalIssuesState | null>(null)
  const [totalReporters, setTotalReporters] = useState<TotalReportersState | null>(null)
  const [totalPorts, setTotalPorts] = useState<TotalPortsState | null>(null)
  const [totalFishermans, setFishermans] = useState<TotalFishermansState | null>(null)
  
  useEffect(() => {
    async function init() {
      if (userState.role === 'admin') {
        let response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/base/countIssues`);
        setTotalIssues((await response.json()));
        response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/base/countBoats`);
        setTotalReporters((await response.json()));
        response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/base/countPorts`);
        setTotalPorts((await response.json()));
        response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/base/countFishermans`);
        setFishermans((await response.json()));
      } else {
        let response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/base/countIssues?apikey=${userState.apikey}`);
        setTotalIssues((await response.json()));
        response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/base/countBoats?apikey=${userState.apikey}`);
        setTotalReporters((await response.json()));
        response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/base/countFishermans?apikey=${userState.apikey}`);
        setFishermans((await response.json()));
      }
    }
    init()
  }, [])

  return (
    <React.Fragment>
        <Col>
          <Card>
            <Card.Body>
              <Card.Title style={{textAlign: "center"}}>
                {totalIssues && numberFormat(totalIssues.countIssues)}
              </Card.Title>
              <Card.Subtitle style={{textAlign: "center"}} className="mb-2 text-muted">Quantidade de Registos</Card.Subtitle>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card>
            <Card.Body>
              <Card.Title style={{textAlign: "center"}}>
                {
                  userState.role === 'admin' ? numberFormat(784,false) : (totalReporters && numberFormat(totalReporters.countBoats,false))
                }
              </Card.Title>
              <Card.Subtitle style={{textAlign: "center"}} className="mb-2 text-muted">
                {
                  userState.role === 'admin' ? "Barcos Aderentes" : "Barcos"
                }
              </Card.Subtitle>
            </Card.Body>
          </Card> 
        </Col>
        {
          userState.role === 'admin' &&
          <Col>
            <Card>
              <Card.Body>
                <Card.Title style={{textAlign: "center"}}>{totalPorts && numberFormat(totalPorts.countPorts)}</Card.Title>
                <Card.Subtitle style={{textAlign: "center"}} className="mb-2 text-muted">Portos Ativos</Card.Subtitle>
              </Card.Body>
            </Card> 
          </Col>
        }
        <Col>
          <Card>
            <Card.Body>
              <Card.Title style={{textAlign: "center"}}>
                {
                  userState.role === 'admin' ? numberFormat(3157,false) : (totalFishermans && totalFishermans.countFishermans)
                }
              </Card.Title>
              <Card.Subtitle style={{textAlign: "center"}} className="mb-2 text-muted">Pescadores</Card.Subtitle>
            </Card.Body>
          </Card> 
        </Col>
    </React.Fragment>
  )
}
